import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";

export const useIsHeadlessApiSubscriptionActive = () => {
  const { currentPlan } = useCurrentPlanApi();

  return Boolean(currentPlan?.api_billing?.is_headless_api_subscription_active);
};
